import { Backdrop, CircularProgress } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import { add, isAfter, isBefore, isDate, set } from 'date-fns'
import MUIDataTable from "mui-datatables"
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import CheckBox from "../../../components/Form/Checkbox"
import DateField from '../../../components/Form/Date'
import { useAuth } from '../../../hooks/auth'
import MvmApi from '../../../services/MvmApi'
import WindowApi from '../../../services/WindowApi'
import utilsDate from '../../../utils/Date'
import getDefaultGridOptions from '../../../utils/componentUtils'
type Props = {
    supplierId: number,
    supplierDescription: string,
    perimeterList: any,
    clickHandlerClose: () => void,
    onSelectWindow: any,
    windowDate: any,
    unforeseenReason?: number
}

interface IFormInput {
    windowDate: any;
    extraVehicle: any,
    offLimitsSystemic: any,
    gathering: any,
    offLimits: any,
    notExistentWindow: any,
    alreadyLinkedWindow: any,
    notLinkedWindow: any,
    spot: any
}

const SelectWindowForm: React.FC<Props> = (props) => {
    const { t: tGeneral } = useTranslation("General")
    const { t: tWindow } = useTranslation("Window")
    const { t: tMvm } = useTranslation("Mvm")
    const [windowList, setWindowList] = useState<any>([])
    const { user } = useAuth()
    const [supplier, setSupplier] = useState<any>([])
    const [selectedWindow, setSelectedWindow] = useState<any>(null)
    const [dateString, setDateString] = useState<string>("")
    const [circularLoading, setCircularLoading] = useState(false)    
    const { enqueueSnackbar } = useSnackbar()
    const { control, setValue, getValues, reset } = useForm<IFormInput>({
        defaultValues: {
            extraVehicle: false,
            offLimitsSystemic: false,
            gathering: false,
            offLimits: false,
            notExistentWindow: false,
            alreadyLinkedWindow: false,
            notLinkedWindow: false,
            spot: false,
        }
    })

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (!props.supplierId || props.supplierId === 0) {

            if (props.clickHandlerClose)
                props.clickHandlerClose()
            return
        }

        var inicialDate = props.windowDate ? new Date(props.windowDate) : new Date()

        setValue("windowDate", inicialDate)
        setDate(inicialDate)
        setUnforeseenReason(props.unforeseenReason)
    }, [props]);

    const setUnforeseenReason = (unforeseenReason: any): void => {
        if (!unforeseenReason)
            return
        
        onSelectCheckBox(unforeseenReason)
    }

    var setDate = async (date: any) => {
        var newDate = isDate(date) ? date : utilsDate.ConvertYYYYMMDDToDate(date)
        getWindows(newDate)

        setDateString(utilsDate.DateShort(newDate))
    }

    //Desabilitar as datas do calendario, deixando habilitado apenas os ultimos 3 ou proximos 5 dias
    const today = set(new Date(), { hours: 0, minutes: 0, seconds: 0, milliseconds: 0});
    const disableDate = (date: any) => {
        let todayPlus5 = add(today, { days: 5});
        let todayMinus3 = add(today, { days: -3});
        
        return isAfter(date, todayPlus5) || isBefore(date, todayMinus3);
    }

    const onSelectCheckBox = (selectedCheckboxNumber: number) => {
        reset({
            "extraVehicle": selectedCheckboxNumber === 1,
            "offLimitsSystemic": selectedCheckboxNumber === 2,
            "gathering": selectedCheckboxNumber === 3,
            "offLimits": selectedCheckboxNumber === 4,
            "notExistentWindow": selectedCheckboxNumber === 5,
            "alreadyLinkedWindow": selectedCheckboxNumber === 6,
            "notLinkedWindow": selectedCheckboxNumber === 7,
            "spot": selectedCheckboxNumber === 8
        });
    }

   const getWindows = async (date: Date) => {
        setCircularLoading(true)
        let params = { 
            suppliersId: props.supplierId.toString(),
            companyId: user.company.companyID, 
            PageSize: 1000, 
            PageIndex: 0,
            flagSunday: date.getDay() === 0 ? true : null,
            flagMonday: date.getDay() === 1 ? true : null,
            flagTuesday: date.getDay() === 2 ? true : null,
            flagWednesday: date.getDay() === 3 ? true : null,
            flagThursday: date.getDay() === 4 ? true : null,
            flagFriday: date.getDay() === 5 ? true : null,
            flagSaturday: date.getDay() === 6 ? true : null
        }

        var usedWindows: any[] = []

        var dateCompare = utilsDate.ConvertDateToStringYYYYMMDD(date)

        await MvmApi.searchTakenDeliveryWindows(user.company.companyID, props.supplierId.toString(), dateCompare).then(result => {
            result.forEach((element: { windowId: any; windowStatus: any; deliveryWindowDate: any, windowStatusDescription: any }) => {
                if (dateCompare === element?.deliveryWindowDate?.split('T')[0]){
                    usedWindows.push({
                        windowId: element.windowId,
                        windowStatus: element.windowStatus,
                        windowStatusDescription: element.windowStatusDescription,
                        deliveryWindowDate:  element.deliveryWindowDate
                    })
                }
            })
        })
        .catch(() => setCircularLoading(false))
        .finally(() => {
            WindowApi.searchWindow(params).then(result => {
                if (result.items)
                    result.items.forEach((element: any) => {
                        var usedWindow = usedWindows.filter(f => f.windowId === element.id)
                        
                        if (usedWindow.length > 0) {
                            element.status = usedWindow[0].windowStatusDescription
                        }
                    })
                setWindowList(result.items)
                buildCollumnsSupplierList(result.items)
            })
            .catch(() => setCircularLoading(false))
   
        })

        setCircularLoading(false)
    }

    
    const myThemeSupplier = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 1,
                    paddingTop: 1
                },
                head: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 1,
                    paddingTop: 1
                }
            },
           
        }
    })
    const [columnsSupplierList, setColumnsSupplierList] = useState<any>([])
    const buildCollumnsSupplierList = (windows : any) => {

        var supplierTemp: Record<string, any> = {supplier: props.supplierDescription}

        var columnsSupplierListTemp = [{
            name: 'supplier',
            label: tMvm('shippingSupplier'),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                  }),
                setCellProps: () => ({
                    align: "left"
                })
            }
        }]

        props.perimeterList.forEach((perimeter: any) => {
            var count = windows.filter((window: { perimeter: any }) => window.perimeter === perimeter).length

            if (count > 0){
                supplierTemp[perimeter] = count

                columnsSupplierListTemp.push({
                    name: perimeter,
                    label: perimeter,
                    options: {
                        sort: false,
                        setCellHeaderProps: () => ({
                            align: "center",
                        }),
                        setCellProps: () => ({
                            align: "center"
                        })
                    }
                })
            }
        })

        setSupplier([supplierTemp])
        setColumnsSupplierList(columnsSupplierListTemp)
    }

    const myThemeWindow = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: windowList.length > 0 ? 'pointer' : ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 1,
                    paddingTop: 1
                },
                head: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 1,
                    paddingTop: 1
                }
            },
           
        }
    })

       const columnsWindow = [
        {
            name: 'id',
            options: { display: false }
        },
        {
            name: 'perimeter',
            label: String(tWindow('perimeter')),
            options: {
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: 'hourConcierge',
            label: String(tWindow('hour')),
            options: {  
                sort: false,              
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return utilsDate.TimeShort(value);
                }
            }
        },
        {
            name: 'status',
            label: 'Status',
            options: {  
                sort: false,              
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                })
            }
        }
    ]

    const myThemeWindowShed = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 1,
                    paddingTop: 1
                },
                head: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 1,
                    paddingTop: 1
                }
            },
           
        }
    })
 
    const columnsWindowShed = [
        {
            name: 'orderShed',
            label: String(tWindow('order')),
            options: {
                sort: false,              
                setCellHeaderProps: () => ({
                    align: "left",
                  }),
                setCellProps: () => ({
                    align: "left"
                })
            }
        },
        {
            name: 'shedCode',
            label: String(tWindow('local')),
            options: {
                sort: false,              
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shedType',
            label: String(tWindow('shedType')),
            options: {
                sort: false,              
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
                customBodyRender: (value: any, tableMeta: any, updateValue: any) => {
                    return value === 'D' ? tWindow('unload') : tWindow('load');
                }
            }
        },
        {
            name: 'movementTypeDescription',
            label: String(tWindow('movementTypeDescription')),
            options: {
                sort: false,              
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'tolerance',
            label: String(tWindow('hourWindowShed')),
            options: {
                sort: false,              
                setCellHeaderProps: () => ({
                    align: "center",
                  }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        }
    ]

    const bindWindow = (withWindow: boolean) => {
        var data = getValues()
        const unforseenReason = (() => {
            switch (true) {
              case data.extraVehicle:
                return 1;
              case data.offLimitsSystemic:
                return 2;
              case data.gathering:
                return 3;
              case data.offLimits:
                return 4;
              case data.notExistentWindow:
                return 5;
              case data.alreadyLinkedWindow:
                return 6;
              case data.notLinkedWindow:
                return 7;
              case data.spot:
                return 8;
              default:
                return null;
            }
          })

        var resp = {
            window: withWindow ? selectedWindow : null,
            unforeseenReason: withWindow ? null : unforseenReason()
        }

        if (withWindow && resp.window == null) {
            enqueueSnackbar(tMvm("selectWindowValidation"), { variant: 'warning' })
            return
        }

        if (!withWindow && resp.unforeseenReason == null) {
            enqueueSnackbar(tMvm("selectUnforeseenReasonValidation"), { variant: 'warning' })
            return
        }

        props.onSelectWindow(resp)
        props.clickHandlerClose()
    }

    return (
        <React.Fragment>
            <form >
                <Backdrop style={{ zIndex: 9999 }} open={circularLoading}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container xs={12} spacing={2} style={{paddingLeft: 0, paddingTop: 0,}}>
                    <Grid xs={8}>
                        <p style={{ marginLeft: 7, marginTop: 20, color: '#597DDA', fontSize: 15 }}>
                            {tMvm("phraseDateVincDeliveryWindow")}
                        </p>
                    </Grid>
                    <Grid xs={3}>
                        <DateField 
                            label={""} 
                            name="windowDate" 
                            control={control} 
                            onChange={(e) => { setDate(e); }}
                            InputLabelProps={{shrink:true}} 
                            shouldDisableDate={disableDate}
                            /> 
                    </Grid>
                    <Grid xs={1}>
                    </Grid>
                </Grid>
                <Grid container spacing={2} style={{paddingLeft: 0, paddingTop: 0,}}>
                    <Grid item xs={12} style={{paddingLeft: 0, paddingTop: 0,}}>
                        <MuiThemeProvider theme={myThemeSupplier}>
                            <MUIDataTable
                                title=""
                                data={supplier}
                                columns={columnsSupplierList}
                                options={{
                                    ...getDefaultGridOptions(tGeneral),
                                    serverSide: false,
                                    pagination: false,
                                    sort: false,
                                    selectToolbarPlacement: "none",
                                    filter: false,
                                    search: false,
                                    download: false,
                                    print: false,
                                    viewColumns: false,
                                    selectableRows: 'none',
                                    tableBodyMaxHeight: `${window.innerHeight - 300}px`,
                                }}
                            />
                        </MuiThemeProvider>
                    </Grid>
                    <Grid item xs={12}  style={{paddingLeft: 0}}>
                        <MuiThemeProvider theme={myThemeWindow}>
                            <MUIDataTable
                                title=""
                                data={windowList} // windowList
                                columns={columnsWindow}
                                options={{
                                    ...getDefaultGridOptions(tGeneral),
                                    serverSide: false,
                                    pagination: false,
                                    sortOrder: {
                                        name: 'hourConcierge',
                                        direction: 'asc'
                                    },
                                    selectToolbarPlacement: "none",
                                    filter: false,
                                    search: false,
                                    download: false,
                                    print: false,
                                    viewColumns: false,
                                    selectableRows: 'none',
                                    tableBodyMaxHeight: `240px`,
                                    onCellClick: (_colData, { colIndex, dataIndex }) => {
                                        var selectedWindowTemp = windowList[dataIndex]
                                        
                                        if (selectedWindowTemp.status != null){

                                            return
                                        }

                                        selectedWindowTemp["deliveryWindowDateString"] = dateString + " " + selectedWindowTemp.hourConcierge
                                        selectedWindowTemp["deliveryWindowDate"] = utilsDate.ConvertDDMMYYYYtoYYYYMMDD(dateString) + "T" + selectedWindowTemp.hourConcierge
                                        setSelectedWindow(selectedWindowTemp)
                                        onSelectCheckBox(0)
                                    }
                                }}
                            />
                        </MuiThemeProvider>
                    </Grid>
                    {!selectedWindow ? <></> :
                        <Grid item xs={12}>
                            <MuiThemeProvider theme={myThemeWindowShed}>
                                <MUIDataTable
                                    title=""
                                    data={selectedWindow.windowSheds}
                                    columns={columnsWindowShed}
                                    options={{
                                        ...getDefaultGridOptions(tGeneral),
                                        serverSide: false,
                                        pagination: false,
                                        sort: false,
                                        selectToolbarPlacement: "none",
                                        filter: false,
                                        search: false,
                                        download: false,
                                        print: false,
                                        viewColumns: false,
                                        selectableRows: 'none',
                                        tableBodyMaxHeight: `${window.innerHeight - 325}px`
                                    }}
                                />
                            </MuiThemeProvider>
                            <Button variant="contained" color="primary" onClick={() => bindWindow(true)} fullWidth={true} style={{marginTop: 20}} >
                                {tMvm("buttonVincDeliveryWindow") + selectedWindow?.deliveryWindowDateString}
                            </Button>
                        </Grid>
                    }
                    
                        <fieldset style={{borderRadius: 8, width: "100%"}}>
                            <legend style={{fontSize: 14, fontWeight: "bold"}}>{tMvm("noWindowRegister")}</legend>
                            <Grid container spacing={1} xs={12} >
                                {/* First Column */}
                                <Grid item xs={6}>
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("extraVehicle")} name="extraVehicle" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 1 : 0)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("offLimitsSystemic")} name="offLimitsSystemic" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 2 : 0)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("gathering")} name="gathering" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 3 : 0)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("offLimits")} name="offLimits" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 4 : 0)} />
                                    </Grid>
                                </Grid>

                                {/* Second Column */}
                                <Grid item xs={6}>                        
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("notExistentWindow")} name="notExistentWindow" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 5 : 0)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("alreadyLinkedWindow")} name="alreadyLinkedWindow" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 6 : 0)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("notLinkedWindow")} name="notLinkedWindow" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 7 : 0)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <CheckBox paddingtop={1} label={tMvm("spot")} name="spot" control={control} onChange={(e) => onSelectCheckBox(e.target.checked ? 8 : 0)} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </fieldset>
                        
                    <Grid item xs={6}>
                        <Button variant="outlined" color="primary" 
                        onClick={() => props.clickHandlerClose()} fullWidth={true} style={{marginTop: 10, marginBottom: 10}} >
                            {tMvm("cancel")}
                        </Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button variant="contained" color="primary" 
                        onClick={() => bindWindow(false)} fullWidth={true} style={{marginTop: 10, marginBottom: 10}} >
                            {tMvm("saveWithoutWindow")}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </React.Fragment>
    )
}
export default SelectWindowForm
